import { FieldPath } from "react-hook-form";

import {
  COHORT_TYPE,
  COUNTRY,
  PAYMENT_TYPE,
  PRODUCT_CATEGORY,
  PRODUCT_TYPE,
  ProductRequest,
} from "../../../models/Product";

export const productDefault: ProductRequest = {
  productDetails: {
    productId: "",
    externalProductId: "",
    brandLogo: "",
    brandName: "",
    expirationDate: "",
    merchantUrl: "",
    merchantTemplateUrl: "",
    originalPrice: undefined,
    paymentType: PAYMENT_TYPE.NONE,
    productBanner: "",
    productCountry: COUNTRY.NONE,
    productImage: "",
    productName: "",
    productType: PRODUCT_TYPE.NONE,
    promoTag: undefined,
    promotionalPrice: undefined,
    startDate: "",
    voucherType: undefined,
    redemptionUrlImage: "",
    productCategory: PRODUCT_CATEGORY.NONE,
    displayTypes: undefined,
    insuranceBidFee: 0,
    noninsuranceBidFee: 0,
    cohortType: COHORT_TYPE.ALL,
    userLimitFrequency: undefined,
    userLimitNumber: undefined,
    voucherLimitFrequency: undefined,
    voucherLimitNumber: undefined,
    voucherExpirationDate: "",
  },
  translationDetails: {
    "en-GB": {
      bannerHeadline: "",
      displayName: "",
      productDescription: "",
      redemptionInstructionHeader: "",
      redemptionInstructions: "",
      termsAndConditions: "",
    },
  },
};

export const requiredForSave: FieldPath<ProductRequest>[] = [
  "productDetails.brandName",
  "productDetails.merchantUrl",
  "productDetails.merchantTemplateUrl",
  "productDetails.productCategory",
  "productDetails.productType",
  "productDetails.promotionalPrice",
  "productDetails.productCountry",
  "translationDetails.en-GB.bannerHeadline",
  "translationDetails.en-GB.displayName",
  "translationDetails.en-GB.productDescription",
  "translationDetails.en-GB.termsAndConditions",
  "productDetails.promoTag",
];

export const requiredForSubmit: FieldPath<ProductRequest>[] = [
  "productDetails.productId",
  "productDetails.brandName",
  "productDetails.externalProductId",
  "productDetails.productName",
  "productDetails.merchantUrl",
  "productDetails.merchantTemplateUrl",
  "productDetails.startDate",
  "productDetails.expirationDate",
  "productDetails.productCategory",
  "productDetails.productType",
  "productDetails.paymentType",
  "productDetails.promotionalPrice",
  "productDetails.productCountry",
  "productDetails.productBanner",
  "productDetails.brandLogo",
  "productDetails.productImage",
  "productDetails.redemptionUrlImage",
  "productDetails.denomination",
  "translationDetails.en-GB.bannerHeadline",
  "translationDetails.en-GB.displayName",
  "translationDetails.en-GB.productDescription",
  "translationDetails.en-GB.termsAndConditions",
];

export const imageFields: FieldPath<ProductRequest>[] = [
  "productDetails.productBanner",
  "productDetails.productImage",
  "productDetails.brandLogo",
  "productDetails.redemptionUrlImage",
];
